import { defineMessages } from 'react-intl';

export default defineMessages({
    Header: {
        id: 'cep.components.sgEndorsementRemoveDriver.Header',
        defaultMessage: 'Remove driver'
    },
    Select: {
        id: 'cep.components.sgEndorsementRemoveDriver.Select',
        defaultMessage: 'Select'
    },
    GoBackLabel: {
        id: 'cep.components.sgEndorsementRemoveDriver.GoBackLabel',
        defaultMessage: 'Back'
    },
    Continue: {
        id: 'cep.components.sgEndorsementRemoveDriver.Continue',
        defaultMessage: 'Continue'
    },
    AdditionalQuestionsHeader: {
        id: 'cep.components.sgEndorsementRemoveDriver.AdditionalQuestionsHeader',
        defaultMessage: 'Additional questions'
    },
    BackToMyAccount: {
        id: 'cep.components.sgEndorsementRemoveDriver.BackToMyAccount',
        defaultMessage: 'Back to My Account'
    }
});
